<script setup lang="ts">
import { UiCard, UiText } from "@shopexperts/shared";
import type { SatelliteContactSiteStats } from "@shopexperts/legacy-api";
import { formatStatLabel, STAT_KEYS } from "@/app/composables/satellite-contact-sites/satelliteSiteFormatters";

defineProps<{
    stats: SatelliteContactSiteStats | null;
    isLoading?: boolean;
}>();
</script>

<template>
    <section class="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <UiCard
            v-for="key in STAT_KEYS"
            :key="key"
            padding="md"
            class="hover:shadow-md transition-shadow"
        >
            <UiText
                as="p"
                variant="caption-normal"
                class="text-se-gray-500 uppercase tracking-wider text-xs"
                :text="formatStatLabel(key)"
            />
            <UiText
                as="p"
                variant="h5"
                class="mt-1 font-semibold tabular-nums text-se-dark"
                :text="isLoading ? '—' : String(stats?.[key] ?? 0)"
            />
        </UiCard>
    </section>
</template>
